import React from 'react';
import { customOauth } from 'actions/oauth-sign-in';
import { toggleNotification } from 'actions/commonActions';
import fbLogo from 'images/fb.png';
import { withStyles } from '@material-ui/core/styles';
import LoaderButton from 'components/LoaderButton';

const styles = {
  fbLogo: {
    width: '23px',
    height: '23px',
    marginRight: '1px',
  },
}

class Facebook extends React.Component {
  state = { fb: window.FB, rerequest: null };

  componentDidMount() {
    window.fbAsyncInit = () => {
      window.FB.init({
        appId      : process.env.FB_APP_ID,
        cookie     : true,  // enable cookies to allow the server to access session
        xfbml      : true,  // parse social plugins on this page
        version    : 'v3.1'
      });

      this.setState({ fb: window.FB });
    };

    (function(d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s); js.id = id;
      js.src = `https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v3.1&appId=${process.env.FB_APP_ID}&autoLogAppEvents=1`;
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
  }

  getLoginStatus = () => {
    this.state.fb.getLoginStatus(response => {
      if (response.status === 'connected') {
        this.fetchUserData({token: response.authResponse.accessToken, expiry: response.authResponse.expiresIn});
      }
//       {
//     status: 'connected',
//     authResponse: {
//         accessToken: '...',
//         expiresIn:'...',
//         reauthorize_required_in:'...'
//         signedRequest:'...',
//         userID:'...'
//     }
// }
    });
  }

  fetchUserData = () => {
    this.state.fb.api('/me?fields=email,first_name,last_name', response => {
      const { email, id, first_name, last_name } = response;
      if (!email || !id) {
        this.setState({ rerequest: 'rerequest' });
        this.props.dispatch(toggleNotification('Unable to login, please grant email access in Facebook.'));
      } else {
        this.props.dispatch(customOauth({ provider: 'facebook', email, uid: id, name: [first_name, last_name].join(' ') }));
      }
    });
  }

  login = () => {
    this.state.fb.login(response => {
      if (response.status === 'connected') {
        this.fetchUserData();
      } else {
        this.props.dispatch(toggleNotification('Unable to login'));
      }
    }, {scope: 'public_profile,email', auth_type: this.state.rerequest});
  }

  icon = () => (<img src={fbLogo} alt='fbLogo' className={this.props.classes.fbLogo} />);

  render = () => {
    return (
      <LoaderButton
        icon={this.icon()}
        onClick={this.login}
      ><span>FACEBOOK</span></LoaderButton>
    )
  }
}

export default withStyles(styles)(Facebook);




// WEBPACK FOOTER //
// ./src/containers/Login/Facebook/index.js